const FinancialService = () => {
  return (
    <div>
      <div className="">
                <img src="/ExpressBanner/banner-4.jpg" width="100%"/>
            </div>
      <div className="flex flex-col justify-center items-center mb-[1.5rem]">
        <hr className="w-[52rem]"/>
        <div className="lg:flex md:grid flex-1 justify-center items-start mx-auto max-w-[60rem] my-[5rem] gap-5 ">
    
          <div className="flex flex-col justify-center">
            <h1 className="font-bold text-3xl text-[#373737]">
              Financial Services
            </h1>
            <p className="text-sm text-md  lg:max-w-[25rem] md:w-[30rem] mt-[1rem]">
              TCS Financial Services aims to be a unique financial services provider in Pakistan
              by creating internal and external strategic alliances. We offer extraordinarily
              customer-oriented products and creative delivery channels to build strong customer
              relationships. Our financial solutions work by employing latest technologies, human
              resource models and forty years of market insights. Our spectrum covers distributing and
              selling financial services to the branchless banking.
            </p>
            
          </div>
          <div className="flex-1 flex flex-col justify-center items-center">
            <img src="/Home/trainingdevelop/traning-1.jpg" alt="" className="max-w-[45rem] h-[30vh]"/>
          </div>
        </div>
      
      </div>
    </div>
  );
};

export default FinancialService;
